import { useState } from "react";
import { useProductCardHandlers } from "./useProductCardHandler";
import type {
  MultipleProductCard,
  SingularProductCard,
  VariantType
} from "@shared/graphql.types";
import type { ProductCardTrackingPayload } from "../types";

interface ProductCardOptions {
  location: string;
  productClickedTrackingPayload?: ProductCardTrackingPayload;
  addToBasketOptions?: {
    afterAdd?: (variant: VariantType) => void;
    beforeAdd?: () => void;
  };
}

export const useProductCard = (
  product: SingularProductCard | MultipleProductCard,
  options: ProductCardOptions
) => {
  const [isShadeSelectorOpen, setIsShadeSelectorOpen] = useState(false);
  const [activeShade, setActiveShade] = useState(0);

  const productHandlers = useProductCardHandlers(product, {
    location: options.location,
    activeShade,
    productClickedTrackingPayload: options.productClickedTrackingPayload || {},
    addToBasketOptions: options.addToBasketOptions || {}
  });

  const handlers = {
    addToBasket: productHandlers.onButtonClick,
    toggleWishlist: productHandlers.onWishlistToggle,
    trackProductClick: productHandlers.onCardClick,
    openShadeSelector: () => setIsShadeSelectorOpen(true),
    closeShadeSelector: () => setIsShadeSelectorOpen(false),
    selectShade: (index: number) => setActiveShade(index)
  };

  return {
    productCardData: productHandlers.productCardData,
    activeVariant: productHandlers.activeVariant,
    isShadeSelectorOpen,
    handlers
  };
};
